import React, {memo} from 'react';
import ReactPlayer from "react-player";
import {r} from "@/utils/responsive";
import {motion} from "motion/react"
import {SectionName} from "@/stores/navigationStore";
import {useNav} from "@/hooks/useNav";

interface ReactPlayerWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    videoSrc: string;
    posterSrc: string;
    blur?: number;
    blurOnSections?: SectionName[]
}

const ReactPlayerWrapper: React.FC<ReactPlayerWrapperProps> = memo(({
                                                                        className,
                                                                        videoSrc,
                                                                        posterSrc,
                                                                        blur = 50,
                                                                        blurOnSections = [],
                                                                        ...props
                                                                    }) => {
    const {currentSection} = useNav()
    return (
        <div style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            pointerEvents: 'none',
            userSelect: 'none',
            zIndex: -1,
            ...props.style
        }}>
            <motion.div initial={{
                opacity: blurOnSections.includes(currentSection) ? 1 : 0,
            }} animate={{
                opacity: blurOnSections.includes(currentSection) ? 1 : 0,
            }} style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                zIndex: 2,
                backdropFilter: `blur(${r.vmax(blur)})`,
                inset: 0
            }}></motion.div>
            <ReactPlayer
                src={videoSrc}
                playing
                autoPlay
                loop
                muted
                width='100%'
                height='100%'
                playsInline
                style={{
                    position: 'absolute',
                    inset: 0,
                    zIndex: 1,
                    ['--media-object-fit' as any]: 'cover'
                }}
            />
            <img src={posterSrc} alt="" style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center',
            }}/>
        </div>
    );
});

export default ReactPlayerWrapper;
